var TimelineInterval;
(function (TimelineInterval) {
    TimelineInterval["EIGHT_HOURS"] = "8h";
    TimelineInterval["FIFHTEEN_MINUTES"] = "15 min";
    TimelineInterval["FIT"] = "Fit";
    TimelineInterval["ONE_HOUR"] = "1h";
    TimelineInterval["THIRTY_MINUTES"] = "30 min";
    TimelineInterval["TWO_HOURS"] = "2h";
})(TimelineInterval || (TimelineInterval = {}));
var TimelinePeriod;
(function (TimelinePeriod) {
    TimelinePeriod["DAY"] = "day";
    TimelinePeriod["HOUR"] = "hour";
    TimelinePeriod["WEEK"] = "week";
})(TimelinePeriod || (TimelinePeriod = {}));
/**
 * @constant  max size of each interval on screen
 * @type {number}
 */
const MAX_INTERVAL_SIZE = 7;
/**
 * @constant Size of information-list in desktop version
 * @type {number}
 */
const INFORMATION_LIST_WIDTH = 15;
/**
 * @constant left padding on initial timeline-tick
 * @type {number}
 */
const RELATIVE_TICK_POSITION = 1.75;
export { INFORMATION_LIST_WIDTH, MAX_INTERVAL_SIZE, RELATIVE_TICK_POSITION, TimelineInterval, TimelinePeriod, };
//# sourceMappingURL=timeline-constants.js.map